import React from 'react';
import { styled } from '@mui/system';
import chip1 from '/images/table/chip-1.svg';
import chip2 from '/images/table/chip-2.svg';
import chip3 from '/images/table/chip-3.svg';
import chip4 from '/images/table/chip-4.svg';
import chip5 from '/images/table/chip-5.svg';
import chip6 from '/images/table/chip-6.svg';
import chip7 from '/images/table/chip-7.svg';
import chip8 from '/images/table/chip-8.svg';
import chip9 from '/images/table/chip-9.svg';
import chip10 from '/images/table/chip-10.svg';
import chip20 from '/images/table/chip-20.svg';
import chip50 from '/images/table/chip-50.svg';
import chip100 from '/images/table/chip-100.svg';
import chip300 from '/images/table/chip-300.svg';
import { isMobile } from 'react-device-detect';

interface PokerChipProps {
    amount: number;
    currency: string;
    suffix: string;
}

const ChipContainer = styled('div')<{ mini?: boolean; size?: string }>(({}) => {
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: '"Inter", serif',
        fontSize: '12px',
        fontWeight: 600,
        backgroundColor: '#3E414D',
        borderRadius: '30px',
        padding: '2px 8px 2px 5px',
        whiteSpace: 'nowrap'
    };
});

const PokerChip: React.FC<PokerChipProps> = ({ amount, currency, suffix }) => {
    const getChipIcon = (bet: number) => {
        if (bet === 0) {
            return chip1;
        } else if (bet === 1) {
            return chip1;
        } else if (bet === 2) {
            return chip2;
        } else if (bet === 3) {
            return chip3;
        } else if (bet === 4) {
            return chip4;
        } else if (bet === 5) {
            return chip5;
        } else if (bet === 6) {
            return chip6;
        } else if (bet === 7) {
            return chip7;
        } else if (bet === 8) {
            return chip8;
        } else if (bet === 9) {
            return chip9;
        } else if (bet >= 10 && bet <= 20) {
            return chip10;
        } else if (bet > 20 && bet <= 50) {
            return chip20;
        } else if (bet > 50 && bet <= 100) {
            return chip50;
        } else if (bet > 100 && bet <= 300) {
            return chip100;
        } else {
            return chip300;
        }
    };

    const formattedAmount = amount % 1 === 0 ? amount : amount.toFixed(2);

    return (
        <ChipContainer>
            <img src={getChipIcon(amount)} width={14} height={14} alt="PokerSolutions Poker Chip" style={{ marginRight: isMobile ? '4px' : '8px' }} />
            {currency}{formattedAmount}{suffix}
        </ChipContainer>
    );
};

export default PokerChip;
